import React from 'react';
import { IconProps } from './types';

const AgentInputIcon: React.FC<IconProps> = props => {
  const { size = 68, fillColor = '#FEF1E1', className } = props;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_12396_45711)">
        <rect x="4" y="2" width="60" height="60" rx="8" fill={fillColor} />
      </g>
      <mask id="mask0_12396_45711" maskUnits="userSpaceOnUse" x="14" y="12" width="40" height="40">
        <rect x="14" y="12" width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12396_45711)">
        <path
          d="M32.3335 47V43.6667H45.6668V31.8333C45.6668 30.2222 45.3613 28.7083 44.7502 27.2917C44.1391 25.875 43.3057 24.6389 42.2502 23.5833C41.1946 22.5278 39.9585 21.6944 38.5418 21.0833C37.1252 20.4722 35.6113 20.1667 34.0002 20.1667C32.3891 20.1667 30.8752 20.4722 29.4585 21.0833C28.0418 21.6944 26.8057 22.5278 25.7502 23.5833C24.6946 24.6389 23.8613 25.875 23.2502 27.2917C22.6391 28.7083 22.3335 30.2222 22.3335 31.8333V42H20.6668C19.7502 42 18.9657 41.6739 18.3135 41.0217C17.6602 40.3683 17.3335 39.5833 17.3335 38.6667V35.3333C17.3335 34.6944 17.4863 34.1317 17.7918 33.645C18.0974 33.1594 18.5002 32.7639 19.0002 32.4583L19.1252 30.25C19.3752 28.2222 19.9518 26.3889 20.8552 24.75C21.7574 23.1111 22.8824 21.7222 24.2302 20.5833C25.5768 19.4444 27.0907 18.5622 28.7718 17.9367C30.4518 17.3122 32.1946 17 34.0002 17C35.8335 17 37.5907 17.3122 39.2718 17.9367C40.9518 18.5622 42.4585 19.4511 43.7918 20.6033C45.1252 21.7567 46.2435 23.1456 47.1468 24.77C48.0491 26.3956 48.6252 28.2083 48.8752 30.2083L49.0002 32.375C49.5002 32.625 49.9029 32.9928 50.2085 33.4783C50.5141 33.965 50.6668 34.5 50.6668 35.0833V38.9167C50.6668 39.5278 50.5141 40.0694 50.2085 40.5417C49.9029 41.0139 49.5002 41.375 49.0002 41.625V43.6667C49.0002 44.5833 48.6741 45.3683 48.0218 46.0217C47.3685 46.6739 46.5835 47 45.6668 47H32.3335ZM29.0002 35.3333C28.5279 35.3333 28.1324 35.1733 27.8135 34.8533C27.4935 34.5344 27.3335 34.1389 27.3335 33.6667C27.3335 33.1944 27.4935 32.7983 27.8135 32.4783C28.1324 32.1594 28.5279 32 29.0002 32C29.4724 32 29.8685 32.1594 30.1885 32.4783C30.5074 32.7983 30.6668 33.1944 30.6668 33.6667C30.6668 34.1389 30.5074 34.5344 30.1885 34.8533C29.8685 35.1733 29.4724 35.3333 29.0002 35.3333ZM39.0002 35.3333C38.5279 35.3333 38.1324 35.1733 37.8135 34.8533C37.4935 34.5344 37.3335 34.1389 37.3335 33.6667C37.3335 33.1944 37.4935 32.7983 37.8135 32.4783C38.1324 32.1594 38.5279 32 39.0002 32C39.4724 32 39.8685 32.1594 40.1885 32.4783C40.5074 32.7983 40.6668 33.1944 40.6668 33.6667C40.6668 34.1389 40.5074 34.5344 40.1885 34.8533C39.8685 35.1733 39.4724 35.3333 39.0002 35.3333ZM24.0418 32.75C23.9307 31.1111 24.1602 29.625 24.7302 28.2917C25.2991 26.9583 26.0624 25.8261 27.0202 24.895C27.9791 23.965 29.0835 23.25 30.3335 22.75C31.5835 22.25 32.8335 22 34.0835 22C36.6113 22 38.7991 22.7989 40.6468 24.3967C42.4935 25.9933 43.6113 27.9861 44.0002 30.375C41.3891 30.3472 39.0279 29.6456 36.9168 28.27C34.8057 26.8956 33.2085 25.1111 32.1252 22.9167C31.6807 25.1667 30.7435 27.1594 29.3135 28.895C27.8824 30.6317 26.1252 31.9167 24.0418 32.75Z"
          fill="#C76B00"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_12396_45711"
          x="0"
          y="0"
          width={size}
          height={size}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12396_45711" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12396_45711"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AgentInputIcon;
